export default function _decisiontree() {
    // Check if the module exists before doing anything
    const decisionTreeExists = !!document.querySelector('.decision-tree');

    // If the module exists, do whatever we need to
    if (decisionTreeExists) {
        // Your code here
        console.log('decision tree JS');
    }
}

_decisiontree();
